import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import { TabList, Tabs, Tab } from 'aquilla/core/molecules/Tabs';

const StyledTabs = styled(Tabs)`
  margin-bottom: ${Spacings.SPACING_12B};
  background: var(--color-base-0);
  ${mediaQuery.uptoMobile} {
    width: 100%;
    top: ${Spacings.SPACING_12B};
  }
`;

const StyledTabsList = styled(TabList)`
  border-bottom: 1px solid var(--color-divider);
`;

const CompeteTabs = ({ tabsData, onChange, selectedTabIndex, children }) => {
  return (
    <>
      <StyledTabs index={selectedTabIndex} onChange={onChange}>
        <StyledTabsList>
          {tabsData.map((tab) => {
            return <Tab key={tab.id}>{tab.name}</Tab>;
          })}
        </StyledTabsList>
        {children}
      </StyledTabs>
    </>
  );
};

export default CompeteTabs;
